export class SelectItem<Value> {
  constructor(
    readonly label: string,
    readonly value: Value,
    readonly limit?: {
      current: number;
      max: number;
    },
  ) {}
}
